import { Search } from 'lucide-react'

import { Button } from '@/components/button'
import * as Input from '@/components/input'
import type { TotalNumberOfBiomes } from '@/models/biomes'
import { normalizeText } from '@/utils/normalize-text'

interface OurPreservationAreasProps {
  setBiome: (value: React.SetStateAction<string>) => void
  setFilter: (value: React.SetStateAction<string>) => void
  biome: string
  filter: string
  biomeAreas: TotalNumberOfBiomes[]
}

export function OurPreservationAreas({
  setBiome,
  setFilter,
  biome,
  filter,
  biomeAreas,
}: OurPreservationAreasProps) {
  return (
    <div className="mx-auto flex flex-col gap-6 md:w-3/5 2xl:w-1/2">
      <h1 className="title">Conheça nossas áreas de conservação</h1>
      <div className="flex flex-col gap-4 md:flex-row">
        <Input.Root className="px-4 py-3 2xl:px-5 2xl:py-4">
          <Input.Prefix>
            <Search className="mr-2 text-zinc-400" />
          </Input.Prefix>

          <Input.Control
            placeholder="Qual é a região da sua preferência?"
            value={filter}
            onChange={(e) => {
              setBiome('')
              setFilter(e.target.value)
            }}
          />
        </Input.Root>
      </div>

      <div className="grid grid-cols-3 gap-3 sm:grid-cols-3 xl:grid-cols-6">
        {biomeAreas.map(
          ({ bioma, total_area_preservada: preservationArea }) => {
            return (
              <Button
                key={bioma}
                variant="outline"
                size="big"
                className="flex-1 text-nowrap border-transparent py-2 hover:bg-transparent aria-selected:bg-transparent"
                asChild
                onClick={() => {
                  setFilter('')
                  if (normalizeText(bioma) === biome) {
                    setBiome('')
                    return
                  }
                  setBiome(normalizeText(bioma))
                }}
                aria-selected={biome === normalizeText(bioma)}
              >
                <div className="flex items-center justify-center">
                  <div className="text-center md:text-start">
                    <p>{bioma}</p>
                    <span className="font-normal">{preservationArea} ha</span>
                  </div>
                </div>
              </Button>
            )
          },
        )}
      </div>

      <p className="text-center text-xl font-medium text-monochromatic-500 2xl:text-2xl">
        O Brasil é o maior detentor de biodiversidade do planeta com seis
        grandes biomas distintos totalizando mais de 850 milhões de hectares.
      </p>
    </div>
  )
}
